// React, store and 3rd party
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import moment from 'moment';

// Components Icons
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';

// Store
import { breadcrumbsActions } from '@store/breadcrumbs';
import { usePermissions } from '@store/auth';
import ApplicationPageTemplate from '@dashboardComponents/ApplicationPageTemplate/ApplicationPageTemplate';
import {
  getTabs,
  paymentOptionsTabsActions,
  selectTabList,
} from '../../store/payment-options-tabs';

import {
  TAB_NEW_ROUTE,
  // TAB_LIST_ROUTE,
  viewTabs,
} from '../../payment-options.breadcrumbs';

import TableToolbar from '../../../../components/TableToolbar';

function TabToolbar({ navigate, permissions }) {
  return (
    <TableToolbar>
      <Button
        disabled={!permissions?.canEditPaymentOptions}
        variant="contained"
        size="large"
        onClick={() => navigate(TAB_NEW_ROUTE)}
        startIcon={<AddIcon />}>
        Add new tab
      </Button>
    </TableToolbar>
  );
}

export default function Tabs() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const permissions = usePermissions();

  const [isFetchingData, setIsFetchingData] = useState(true);

  const tabs = useSelector(selectTabList);

  // const getModifiedDetails = ({ row }) =>
  //   moment(row.modifiedAt).format('YYYY/MM/DD - HH:mm');

  useEffect(() => {
    dispatch(breadcrumbsActions.showMenu(true));
    dispatch(breadcrumbsActions.setBreadcrumbs(viewTabs));
    dispatch(paymentOptionsTabsActions.resetSelectedTab());
  }, [dispatch]);

  useEffect(() => {
    setIsFetchingData(true);
    dispatch(getTabs()).then(() => {
      setIsFetchingData(false);
    });
  }, [dispatch]);

  return (
    <ApplicationPageTemplate
      title="Tabs"
      description="List of configured tabs. You can also the page to add and update tabs."
      pageReady={!isFetchingData}>
      <DataGrid
        density="compact"
        style={{ background: 'white' }}
        rows={tabs}
        rowsPerPageOptions={[20]}
        pageSize={20}
        disableSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        disableDensitySelector
        components={{
          Toolbar: () => TabToolbar({ navigate, permissions }),
        }}
        componentsProps={{
          toolbar: {
            csvOptions: { disableToolbarButton: true },
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
          },
        }}
        // @TODO: Uncomment once API is available
        // onRowClick={({ row }) => {
        //   navigate(`${TAB_LIST_ROUTE}/${row.id}`);
        // }}
        getRowId={(row) => row.id}
        columns={[
          {
            field: 'id',
            headerName: 'ID',
            sortable: false,
            headerAlign: 'center',
            align: 'center',
          },
          {
            field: 'name',
            headerName: 'Name',
            flex: 1,
            headerAlign: 'left',
            align: 'left',
          },
          {
            field: 'code',
            headerName: 'Code',
            flex: 1,
            headerAlign: 'left',
            align: 'left',
          },
          {
            field: 'defaultPriority',
            headerName: 'Default Priority',
            flex: 1,
            sortable: false,
            headerAlign: 'center',
            align: 'center',
          },
          // {
          //   field: 'modifiedBy',
          //   headerName: 'Modified By',
          //   flex: 1,
          //   sortable: false,
          //   headerAlign: 'center',
          //   align: 'center',
          // },
          // {
          //   field: 'modifiedAt',
          //   headerName: 'Last Modified Date',
          //   flex: 1,
          //   sortable: false,
          //   headerAlign: 'right',
          //   align: 'right',
          //   valueGetter: getModifiedDetails,
          // },
        ]}
      />
    </ApplicationPageTemplate>
  );
}
